import { useNavigate } from "react-router-dom";
// src/pages/EngineSettingsPage.jsx вЂ” v2.2 FIXED
//
// BUG: EngineInfoBlock + Panel were injected INSIDE SectionTitle function body
// causing infinite recursive rendering в†’ crash on /engine.
// FIX: Move EngineInfoBlock Panel to correct position in EngineSettingsPage render.

import ProtectionModeSelector from "../components/engine/ProtectionModeSelector";
import EngineInfoBlock         from "../components/engine/EngineInfoBlock";
import SystemStateIndicator   from "../components/engine/SystemStateIndicator";
import TimelineView           from "../components/engine/TimelineView";
import { useState }           from "react";

function SectionTitle({ title }) {
  return (
    <div style={{
      fontFamily:    "var(--font-mono)",
      fontSize:      9,
      letterSpacing: "0.18em",
      textTransform: "uppercase",
      color:         "var(--text-muted)",
      marginBottom:  12,
    }}>
      {title}
    </div>
  );
}

function Panel({ children, style }) {
  return (
    <div style={{
      background:   "var(--bg-card)",
      border:       "1px solid var(--border-subtle)",
      borderRadius: "var(--radius)",
      padding:      "20px",
      ...style,
    }}>
      {children}
    </div>
  );
}

export default function EngineSettingsPage() {
  const navigate = useNavigate();
  const [selectedCampaign, setSelectedCampaign] = useState("");

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 24 }}>
      {/* Return to Analyze */}
      <div data-no-print style={{ display: "flex", alignItems: "center", marginBottom: 4 }}>
        <button
          onClick={() => navigate("/analyze")}
          style={{
            fontFamily: "var(--font-mono)", fontSize: 10, cursor: "pointer",
            padding: "4px 10px", borderRadius: "var(--radius-sm)",
            background: "transparent", border: "1px solid var(--border-subtle)",
            color: "var(--text-muted)", display: "inline-flex", alignItems: "center", gap: 5,
          }}
        >
          ← Analyze
        </button>
      </div>

      {/* Header */}
      <div>
        <div style={{
          fontFamily:  "var(--font-mono)", fontSize: 16,
          fontWeight:  700, color: "var(--text-primary)",
          marginBottom: 4,
        }}>
          Analysis Engine
        </div>
        <div style={{
          fontFamily: "var(--font-mono)", fontSize: 11,
          color:      "var(--text-muted)",
        }}>
          v1.2 В· Configuration
        </div>
      </div>

      {/* Protection Mode */}
      <Panel>
        <SectionTitle title="Protection Mode" />
        <ProtectionModeSelector />
      </Panel>

      {/* System State */}
      <Panel>
        <SectionTitle title="Campaign States" />
        <SystemStateIndicator />
      </Panel>

      {/* Timeline */}
      <Panel>
        <SectionTitle title="Decision Timeline" />
        <div style={{ marginBottom: 12 }}>
          <input
            type="text"
            value={selectedCampaign}
            onChange={e => setSelectedCampaign(e.target.value)}
            placeholder="Campaign ID (e.g. cmp_123)"
            style={{
              fontFamily:   "var(--font-mono)", fontSize: 12,
              background:   "var(--bg-base)",
              border:       "1px solid var(--border-subtle)",
              borderRadius: "var(--radius-sm)",
              padding:      "8px 12px",
              color:        "var(--text-primary)",
              width:        "100%",
              outline:      "none",
            }}
          />
        </div>
        {selectedCampaign
          ? <TimelineView campaignId={selectedCampaign} />
          : (
            <div style={{
              fontFamily: "var(--font-mono)", fontSize: 11,
              color:      "var(--text-muted)", textAlign: "center",
              padding:    "20px 0",
            }}>
              Enter a campaign ID to view its decision history
            </div>
          )
        }
      </Panel>

      {/* About VIRAJ вЂ” strategic context */}
      <Panel>
        <SectionTitle title="About VIRAJ" />
        <EngineInfoBlock />
      </Panel>

    </div>
  );
}


